const TOKEN_KEY = 'token';

export const getToken = () => localStorage.getItem(TOKEN_KEY) || null;

export const setToken = (value) => localStorage.setItem(TOKEN_KEY, value);
